import { z } from "zod";

import DataList, {
  type DataListProps,
} from "@/components/ui/chat/data-list/DataList";

/** Chat catalog definition for DataList. */
export const ChatDataListSpec = {
  props: z.object({
    items: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      }),
    ),
    orientation: z.enum(["vertical", "horizontal"]).nullable().optional(),
  }),
  description:
    "Key-value list for structured metadata (publisher, date, sentiment, impact score, category). Props: items (array of { label, value }), optional orientation 'vertical' (default grid) | 'horizontal' (wrapped inline pairs) | null.",
  example: {
    items: [
      { label: "Publisher", value: "Reuters" },
      { label: "Sentiment", value: "Positive" },
      { label: "Impact Score", value: "8.4 / 10" },
    ],
    orientation: "vertical",
  },
} as const;

/** Adapter for json-render defineRegistry: renders DataList from catalog props. */
export const ChatDataListFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => (
  <div className="w-full min-w-0">
    <DataList {...(props as unknown as DataListProps)} />
  </div>
);
